import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { BcEmailOutgoingHeaderComponent } from './email-outgoing-header.component';
import { DropdownModule } from '../dropdown/dropdown.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    DropdownModule,
    FormsModule
  ],
  providers: [],
  declarations: [
    BcEmailOutgoingHeaderComponent
  ],
  exports: [
    BcEmailOutgoingHeaderComponent
  ]
})
export class EmailOutgoingHeaderModule {}
